import { type Variants } from 'framer-motion';
import checkUndefinedNullOrEmpty from '../../utils/tools/checkUndefinedNullOrEmpty';
import { type VariantsType } from './types';
import { varFade, varFlip, varSlide, varZoom } from './variants';

export * from './variants';

type AnimationType = {
    i: string;
    f: (props?: VariantsType) => any;
    directions?: [{ i: 'none'; field: string }, { i: '-left'; field: string }, { i: '-right'; field: string }, { i: '-up'; field: string }, { i: '-down'; field: string }];
};

const animationTypes: AnimationType[] = [
    { i: 'none', f: null },
    {
        i: 'fade',
        f: varFade,
        directions: [
            { i: 'none', field: 'in' },
            { i: '-left', field: 'inRight' },
            { i: '-right', field: 'inLeft' },
            { i: '-up', field: 'inDown' },
            { i: '-down', field: 'inUp' },
        ],
    },
    {
        i: 'flip',
        f: varFlip,
        directions: [
            { i: 'none', field: 'inX' },
            { i: '-left', field: 'inX' },
            { i: '-right', field: 'inX' },
            { i: '-up', field: 'inY' },
            { i: '-down', field: 'inY' },
        ],
    },
    {
        i: 'slide',
        f: varSlide,
        directions: [
            { i: 'none', field: 'in' },
            { i: '-left', field: 'inRight' },
            { i: '-right', field: 'inLeft' },
            { i: '-up', field: 'inDown' },
            { i: '-down', field: 'inUp' },
        ],
    },
    {
        i: 'zoom-in',
        f: varZoom,
        directions: [
            { i: 'none', field: 'in' },
            { i: '-left', field: 'inRight' },
            { i: '-right', field: 'inLeft' },
            { i: '-up', field: 'inDown' },
            { i: '-down', field: 'inUp' },
        ],
    },
    {
        i: 'zoom-out',
        f: varZoom,
        directions: [
            { i: 'none', field: 'out' },
            { i: '-left', field: 'outRight' },
            { i: '-right', field: 'outLeft' },
            { i: '-up', field: 'outDown' },
            { i: '-down', field: 'outUp' },
        ],
    },
];

export function getAnimation(props: {
    type: 'none' | 'fade' | 'flip' | 'slide' | 'zoom-in' | 'zoom-out';
    direction: 'none' | '-left' | '-right' | '-up' | '-down';
    distance?: number;
    duration?: number;
    delay?: number;
}): Variants {
    const { type, direction, distance, duration, delay } = props;
    const animationType = animationTypes?.find((a) => a?.i === type);
    if (!checkUndefinedNullOrEmpty(animationType?.f)) {
        const typeFunc = animationType.f;
        const typeDirection = animationType?.directions?.find((d) => d?.i === direction)?.field;

        if (!checkUndefinedNullOrEmpty(typeFunc) && !checkUndefinedNullOrEmpty(typeDirection)) {
            return typeFunc({
                distance: !checkUndefinedNullOrEmpty(distance) ? distance : undefined,
                delayIn: !checkUndefinedNullOrEmpty(delay) ? delay / 1000 : undefined,
                delayOut: !checkUndefinedNullOrEmpty(delay) ? delay / 1000 : undefined,
                durationIn: !checkUndefinedNullOrEmpty(duration) ? duration / 1000 : undefined,
                durationOut: !checkUndefinedNullOrEmpty(duration) ? duration / 1000 : undefined,
            })[typeDirection];
        }
        return null;
    }

    return null;
}
